import * as React from 'react';
import './style/index.scss';
import { ErrorBoundary } from './ErrorBoundary';
import { ContactUsFormWrapper } from './ContactUsFormWrapper';
export class ContactUsForm extends React.Component {
    render() {
        const caseDeflection = this.props.showCaseDeflection === undefined ?
            false : this.props.showCaseDeflection;
        return (React.createElement("div", { className: "contact-us-form" },
            React.createElement(ErrorBoundary, null,
                React.createElement(ContactUsFormWrapper, { productName: this.props.productName, pageSource: this.props.pageSource, onSubmitFn: this.props.onSubmitFn, onClose: this.props.onClose, articles: this.props.articles, initialSearchTerms: this.props.initialSearchTerms, isVisible: this.props.isVisible, searchTermCallBack: this.props.searchTermCallBack, goToArticle: this.props.goToArticle, showCaseDeflection: caseDeflection }))));
    }
}
export default { ContactUsForm };
